import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import { DeserializeVoid, _post } from '../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class SetAdjustmentNeedsDesignControllerRequestService {
  private readonly post: <T>(
    path: string,
    body: any,
    deserialize: (response: any) => T
  ) => Observable<T>;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post('/subprojects', requestServices);
  }

  public setAdjustmentNeedsDesign(
    adjustmentId: number,
    designerId: number | null,
    designByDate: Date | null,
    needsDesignDescription: string | null
  ): Promise<void> {
    return this.post(
      '/setAdjustmentNeedsDesign',
      {
        adjustmentId: adjustmentId,
        designerId: designerId,
        designByDate: designByDate,
        needsDesignDescription: needsDesignDescription,
      },
      DeserializeVoid
    ).toPromise();
  }
}
